export default __webpack_public_path__ + "static/media/picto_4.f2416258.png";